import { useRouter } from "next/router";
import en from "./en.json";
import { useCallback, useEffect, useState } from "react";

export const useLocale = () => {
  const router = useRouter();
  const [locale, setLocale] = useState(en);

  const allLocales = {en};

  const getLocale = useCallback(() => {
    setLocale(allLocales[router.locale as never]);
  }, [router.locale]);

  useEffect(() => {
    getLocale();
  }, []);
  return { locale };
};
